import { size } from '@floating-ui/react-dom';

import type {
  Boundary,
  Middleware,
  MiddlewareState,
  Padding,
} from '@floating-ui/react-dom';

interface ResizeOnShowOptions {
  boundary?: Boundary | undefined;
  padding?: Padding;
  isHidden?: boolean;
  minHeight?: number;
}

const CONTENT_VISIBLE_THRESHOLD = 5;
const DATA_ATTRIBUTE = 'fixedHeight';

const resizeOnShow = (options: ResizeOnShowOptions): Middleware =>
  size({
    ...options,
    apply(state: MiddlewareState & { availableHeight: number }) {
      // Skip computations if there's no content in the floating element
      if (
        options.isHidden ||
        state.elements.floating.clientHeight <= CONTENT_VISIBLE_THRESHOLD
      ) {
        return;
      }

      const padding = normalizePadding(options.padding);

      // eslint-disable-next-line no-param-reassign
      state.elements.floating.style.maxWidth = `calc(100% - ${padding.left}px - ${padding.right}px)`;

      if (!state.elements.floating.dataset[DATA_ATTRIBUTE]) {
        const maxHeight = Math.max(
          state.availableHeight,
          options.minHeight || 0,
        );

        // eslint-disable-next-line no-param-reassign
        state.elements.floating.style.maxHeight = `${maxHeight}px`;
        // eslint-disable-next-line no-param-reassign
        state.elements.floating.dataset[DATA_ATTRIBUTE] = 'true';
      }
    },
  });

const normalizePadding = (padding?: Padding) => {
  if (typeof padding === 'number') {
    return { left: padding, right: padding, top: padding, bottom: padding };
  }
  return {
    left: padding?.left ?? 0,
    right: padding?.right ?? 0,
    top: padding?.top ?? 0,
    bottom: padding?.bottom ?? 0,
  };
};

export default resizeOnShow;
